export default "__VITE_ASSET__BHDahVC$__"